$( function() {   
    $('section:in-viewport').addClass('animated');
    fixedNav();
    checkVisibleSections();
    scrollToElem();
    scrollToUp();
    playVideo();
    initSlider();
    parallax();
    btnSocial();
//    clickOrder();
    validateForms();
    initPopup();
    initPhoneMask();
});


$(window).load(function(){
    checkVisibleSections();
});
$(window).scroll(function(){
    checkVisibleSections();
});

function clickOrder (){
    $('.reg__order').click(function(event){
        yaCounter23720797.reachGoal("ORDER");
    });
    event.preventDefault();
}

function initPhoneMask() {
    $('input[type="tel"]').mask("+7 (999) 999-99-99");
}
function initPopup() {
    
    $('.registration__btn').fancybox({
        
    });
    
}

function validateForms() {
    $.extend($.validator.messages, {
        required: "Это поле необходимо заполнить.",
        remote: "Пожалуйста, введите правильное значение.",
        email: "Пожалуйста, введите корректный адрес электронной почты.",
        url: "Пожалуйста, введите корректный URL.",
        date: "Пожалуйста, введите корректную дату.",
        dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
        number: "Пожалуйста, введите число.",
        digits: "Пожалуйста, вводите только цифры.",
        creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
        equalTo: "Пожалуйста, введите такое же значение ещё раз.",
        extension: "Пожалуйста, выберите файл с правильным расширением.",
        maxlength: $.validator.format("Пожалуйста, введите не больше {0} символов."),
        minlength: $.validator.format("Пожалуйста, введите не меньше {0} символов."),
        rangelength: $.validator.format("Пожалуйста, введите значение длиной от {0} до {1} символов."),
        range: $.validator.format("Пожалуйста, введите число от {0} до {1}."),
        max: $.validator.format("Пожалуйста, введите число, меньшее или равное {0}."),
        min: $.validator.format("Пожалуйста, введите число, большее или равное {0}.")
    });

    $('form').each(function(){
        $(this).validate({
            validClass: 'valid',
            errorElement: 'div',
            submitHandler: function(form){
                handleSubmitForm({}, $(form) );
                $(form).trigger('reset');
            },
            highlight: function(element, errorClass, validClass) {
                $(element).addClass('error').removeClass('valid');

            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass('error').addClass('valid');
            },
            errorPlacement: function(error, element) {
                return true;
            },
        });
    });
}


function handleSubmitForm(event, el) {
    var form = $(el);

    $.ajax({
        type: 'post',
        url: form.attr('action'),
        data: form.serialize(),
        beforeSend: function(){            
            $.fancybox('#tnx__popup',{
                
            });                
            $('form').trigger('reset');
            yaCounter23720797.reachGoal("LANDING_STUDENT_ORDER");
        },
        success: function(msg) {
            if (msg == 'ok') {} else {}
        }
    });
}

function  btnSocial() {
    $('.open_ico').click(function(event){
        $('.close_ico').removeClass('hide');
        $('.footer_recomendation_wrap__list').removeClass('hide');
        $('.open_ico').addClass('hide');
        if($('.open_ico').hasClass('hide')){
            $('.close_ico').click(function(event){
                $('.close_ico').addClass('hide'); 
                $('.footer_recomendation_wrap__list').addClass('hide');
                $('.open_ico').removeClass('hide');
            });
        }
    });
    event.preventDefault();
}


function checkVisibleSections() {
    $('section:in-viewport').addClass('animated');      


    var visiblePercent = $(window).height() / 100 * 49;
    var $sections = $([]);

    $('nav a').each(function(){
        $sections = $sections.add($(this.hash));
    });
    var $menuItems = $('nav li');
    if(!$sections.filter(':in-viewport(' + visiblePercent +')').length) return;

    $sections.removeClass('visible');
    $menuItems.find('a').removeClass('active');
    $sections.filter(':in-viewport(' + visiblePercent +')').addClass('visible');

    var id = "#" + $sections.filter('.visible').attr('id');
    $menuItems.find('a[href="' + id + '"]').closest('a').addClass('active');
}

function scrollToElem() {
    $('nav a').click(function(e){
        var href = this.hash;
        if(!$(href).length) return;

        var distance = $(window).scrollTop() - ($(href).offset().top);
        var speed = (distance > 0) ? distance / 4 : distance * -1 / 4;

        var headerOffset = $('nav').outerHeight();

        $('html, body').animate({scrollTop: ($(href).offset().top - headerOffset)}, speed);
        e.preventDefault();
    });
}

function initSlider() {
    $('.comments__list').each(function() {
        var next = $(this).siblings('.arrow_right');
        var prev = $(this).siblings('.arrow_left');
        //        var dots = $(this).siblings('.dots');
        $(this).cycle({
            slides: '> .comments__list-item',
            fx: 'scrollHorz',
            speed: 1500,
            timeout: 5000,
            next: next,
            prev: prev,           
            paused: false
        });
    });
}

function scrollToUp() {
    $(".button-up").click(function() {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    });
}
function scrollToSendForm() {
    $(".scrollToForm").click(function() {
        $('html, body').animate({
            scrollTop: $("#form2").offset().top
        }, 500);       
        return false;

    });
}


function fixedNav() {
    $("#menu").sticky({ topSpacing: 0 });
}

function playVideo() {
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubePlayerAPIReady() {
    var yplayer = new YT.Player('player-1', {
        events: {
            'onStateChange': loopVideo
        }
    });
    var yplayer2 = new YT.Player('player-2', {
        events: {
            'onStateChange': loopVideo
        }
    });

    //    $('.slogan__video_btn').click(function(){
    //        yplayer.playVideo();
    //        $('#player-1').parent().fadeIn();
    //    });

    function loopVideo(event) {
        if (event.data == YT.PlayerState.ENDED) {
            yplayer.seekTo(0).playVideo();
            yplayer2.seekTo(0).playVideo();
        }
    }
    //    function hideVideo(event) {
    //        if (event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED) {
    //            $('#player-1').parent().fadeOut();
    //        }
    //    }
}


function parallax() {
    $('.parallax').parallax();
}